import { render, staticRenderFns } from "./FullTaskInfo.vue?vue&type=template&id=6b42e1c0&scoped=true&"
import script from "./FullTaskInfo.vue?vue&type=script&lang=js&"
export * from "./FullTaskInfo.vue?vue&type=script&lang=js&"
import style0 from "./FullTaskInfo.vue?vue&type=style&index=0&id=6b42e1c0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b42e1c0",
  null
  
)

export default component.exports